/**
 * The workflows gestation chat's starter set (`ChatStarterSet` strategy —
 * see `components/chat/chatStarters.ts`). This thread exists to author a
 * praxis spec, so BOTH prompts are deliberately spec-shaped: they carry a
 * trigger condition + action verbs + an integration + a multi-step
 * sequence, tripping the agent's ≥2 spec-shape detector (claw-doctrine
 * §5.6.3) so it reaches for `praxis spec create`, never a free-hand chat
 * plan. The generic chat starters (daily briefing, market analysis…) are
 * one-shot asks — wrong surface here.
 *
 * Two templates, grounded in what the platform actually backs today:
 *  - Inbox triage — the §5.6.3 canonical example; email channel is live,
 *    approval holds are real (`actor: human` gates).
 *  - Weekly digest — the workflows mockup's hero ("Word Bookstore
 *    pricing"): gather → summarize → email, pricing held for approval.
 *    The weekly cadence lives in the spec's `## Triggers` declaration;
 *    runs today fire manually / by chat (no scheduler — praxis §10.5).
 */

import { Inbox, Newspaper } from "lucide-react";

import type { ChatStarterSet } from "@/components/chat/chatStarters";

export const WORKFLOW_CHAT_STARTERS: ChatStarterSet = {
  intro: "Pick a job to teach Clawbert — or describe your own below.",
  starters: [
    {
      id: "inbox-triage",
      icon: Inbox,
      tone: "bg-home-sky/25 text-home-water",
      label: "Inbox triage",
      hint: "Sort, draft, hold for you",
      prompt:
        "Set up a workflow that triages my inbound email: when a new email arrives, read it, sort it (needs my reply / FYI / ignore), draft a reply for anything that needs me, and hold every draft for my approval before sending.",
    },
    {
      id: "weekly-digest",
      icon: Newspaper,
      tone: "bg-accent-green/12 text-accent-green",
      label: "Weekly digest",
      hint: "Gather, summarize, email me",
      prompt:
        "Set up a workflow that builds my weekly digest: gather what changed this week in [your area — reviews, mentions, a topic], write a short summary with highlights and action items, and email it to me. Hold anything that touches pricing for my ok first.",
    },
  ],
};
